// extracted by mini-css-extract-plugin
var _1 = "Palette_root__c3097";
export { _1 as "root" }
